const style = {
  header: {
    marginTop: '-94px',
    display: 'flex',
    minHeight: '95px',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    borderBottom: '1px solid #c4c4c4',
  },

  top: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#354052',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '25px 15px 5px',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
  },
  count: {
    display: 'flex',
    alignItems: 'center',
  },

  countIndicatorWrapper: {
    height: '14px',
  },

  content: {
    width: '100%',
  },

  share: {
    cursor: 'pointer',
  },
  mail: {
    cursor: 'pointer',
    marginRight: '6px',
  },
}

export default style
